import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { EnhancedTable, ConfigContext } from '../m34n-ui/src/lib';
import ProductAddModal from './ProductAddModal';
import { TableCell, Button, Chip } from '@mui/material';  // Import Chip
import { useContext, useState } from 'react';

export default function ProductGrid() {
    const gridRef = useRef();
    const navigate = useNavigate();
    const { config } = useContext(ConfigContext);
    const [productAddModalIsOpen, setProductAddModalIsOpen] = useState(false);

    const headCells = [
        { id: 'name', numeric: false, disablePadding: true, label: 'Product Name' },
        { id: 'description', numeric: false, disablePadding: true, label: 'Description' },
        {
            id: 'price', numeric: false, disablePadding: true, label: 'Price',
            render: ({ rowData, index }) => {
                const Prices = () => {
                    return rowData.registrationTypes.map((type, index) => (
                        <Chip
                            key={index}
                            label={`${type.name}: $${type.price}`}
                            variant="outlined"
                            color="primary"
                            style={{ margin: '2px' }}
                        />
                    ));
                };
                return (
                    <TableCell key={index} align="left">
                        <Prices />
                    </TableCell>
                );
            }
        },
        { id: 'createdAt', numeric: false, disablePadding: true, label: 'Created' },
        {
            id: 'deleted', numeric: false, disablePadding: true, label: 'Is Deleted',
            render: ({ rowData, index }) => (
                <TableCell key={index} align="left">{rowData.deleted ? 'Yes' : 'No'}</TableCell>
            )
        },
    ];

    const filterList = [
        { id: 'name', dataType: 'string', label: 'Product Name', defaultValue: '' },
        { id: 'description', dataType: 'string', label: 'Description', defaultValue: '' },
        { id: 'price', dataType: 'string', label: 'Price', defaultValue: '' },
        { id: 'deleted', dataType: 'boolean', label: 'Is Deleted', defaultValue: false },
    ];

    return (
        <div>
            <Button variant="contained" color="primary" onClick={() => setProductAddModalIsOpen(true)}>
                Add Product
            </Button>
            <ProductAddModal
                config={config}
                isOpen={productAddModalIsOpen}
                onChangeBulk={setProductAddModalIsOpen}
            />
            <EnhancedTable
                ref={gridRef}
                tableName="Products"
                searchEndpont={`${config.uri.base}/product`}
                actionRowClick={({ rowData }) => navigate(`/admin/product/${rowData._id}`)}
                actionDelete={async () => {
                    location.reload();
                }}
                headCells={headCells}
                filterList={filterList}
            />
        </div>
    );
}

